import React, { Component } from "react";

class Info extends Component {
    render() {
        return(
            <>
            <section class="section" id="course">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="feature_header text-center">
                                <h3 class="feature_title no-transform">COURSE</h3>
                                <h4 class="feature_sub">
                                    Do you like beer? Ever wondered why beer tastes the way it does?
                                    Then you are at the right place! Our course certified by the Ministry of Education will introduce you
                                    to the science underlying beer brewing. You will learn how the ingredients,
                                    different biochemical reactions, and processes in beer brewing
                                    influence the taste and aroma of beer. What’s more,
                                    you will get the chance to brew beer in a university brewery!
                                    <br /><br />
                                    You will learn all about beer in the city, which has been voted the most beautiful
                                    city in the world. You will explore the city of Awesome Prague, its unique historical atmosphere,
                                    and pulsating nightlife. Moreover, you will spend a wonderful weekend trip in the Czech nature.
                                    And you won’t be alone in this. All of this not only with us, the organizers from Awesome Prague,
                                    but mainly with other 20 participants from all over Europe!
                                    <br /><br />
                                    But DO NOT worry, we are preparing much more for you, from city rallies to the most incredible once-in-a-lifetime parties. Our goal is to make the most unforgettable memories for you!

                                </h4>
                                <br />
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/D5aTUdZrkjk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                <br/><br/>
                                {/*<p class="fb-event">fb<br />
                                    <a target="_blank" href="https://www.facebook.com/events/183293470599103/"
        class="btn btn-fb"><i class="fa fa-facebook"></i>&nbsp; course on fb</a></p>*/}
                                <div class="row">
                                    <div class="main_feature text-center">
                                        <div class="col-md-6 col-xs-12 col-sm-4">
                                            <div class="feature_content">
                                                <i class="fa fa-inbox"></i>

                                                <h3>Materials</h3>

                                                <p>Do you need more information? </p>
                                                <p>Are you looking for Survival Guide or pre-materials? </p>
                                                <p>You are on a right place. Every document you may need you can find here. :)</p>

                                                <a href="#materials" class="btn btn-main"> Materials</a>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xs-12 col-sm-4">
                                            <div class="feature_content">
                                                <i class="fa fa-users"></i>

                                                <h3>Core Team</h3>

                                                <p>Do you wonder who is organising this awesome summer course?</p>
                                                <p>Who stand behind your unforgettable summer?</p>
                                                <p>Check who is part of this awesome Core Team.</p>

                                                <a href="#ct" class="btn btn-main">Core Team</a>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                <br/><br/>
                                <div class="divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            </>
        );
    }
}

export default Info;